export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10023.f559a8c2.jpg";